import React, { useEffect, useRef, useState } from 'react';
import IDataSourceProps from '../../../../../../../../../shared/contracts/IDataSourceProps';
import useWizardDataSource from './useWizardDataSource';
import { Autocomplete, Box, darken, lighten, TextField } from '@mui/material';


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function WizardDataSourceComponent({
    count, isAddNew = false, inputRef, error,
    defaultItem, originalList, reservedList,
    onDataSourceChanged
}: {
    count?: number;
    isAddNew?: boolean;
    error: string | null;
    defaultItem: IDataSourceProps | null;
    originalList: IDataSourceProps[];
    reservedList: IDataSourceProps[];
    onDataSourceChanged: (prev: IDataSourceProps | null, next: IDataSourceProps | null) => void;
    inputRef?: React.MutableRefObject<HTMLDivElement | null>;
}) {

    const [inputValue, setInputValue] = useState('');

    const {
        filteredList: options, selectedItem, setSelectedItem
    } = useWizardDataSource({ defaultItem, originalList, reservedList })

    const handleSelectionChange = (e: any, newValue: IDataSourceProps | null) => {
        if (isAddNew) {
            onDataSourceChanged(null, newValue);
            setSelectedItem(null); // Explicitly set to null
            setInputValue('');
        } else {
            if (!selectedItem && newValue) { // add
                onDataSourceChanged(selectedItem, newValue);
                setSelectedItem(newValue);
            } else if (selectedItem && !newValue) { // clear
                onDataSourceChanged(selectedItem, newValue);
                setSelectedItem(newValue);
            } else if (selectedItem && newValue  // updated
                && selectedItem.dataSourceCode !== newValue.dataSourceCode) {
                onDataSourceChanged(selectedItem, newValue);
                setSelectedItem(newValue);
            }
        }

    }


    useEffect(() => {
        if (inputRef && inputRef.current && isAddNew) {
            inputRef.current.focus();
        }
    }, []);

    return (<Autocomplete
        size='small'
        // sx={{ width: 412 }}
        value={selectedItem}
        onChange={handleSelectionChange}
        inputValue={inputValue}
        onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
        options={options}
        groupBy={(option) => option.dataSourceCategory}
        getOptionLabel={(option) => (option ? option.dataSourceName : '')}
        renderInput={(params) =>
            <TextField
                // error={error ? true : false}
                // helperText={error || null}
                {...params}
                inputRef={inputRef}
                label={isAddNew ? 'Add a new data source' : `Data Source-${count}`}
                placeholder={isAddNew ? 'Select or Search...' : undefined}
                error={!!error} // Show error only if there is an error message
                helperText={error ? error : undefined} // Show helper text only if there is an error
            />}
        renderGroup={(params) => (
            <li key={params.key}>

                {/* Group Header styling using sx */}
                <Box sx={(theme) => ({
                    position: 'sticky', top: '-8px', padding: '4px 10px',
                    color: theme.palette.primary.main,
                    backgroundColor: lighten(theme.palette.primary.light, 0.85),
                    ...(theme.palette.mode === 'dark' && {
                        backgroundColor: darken(theme.palette.primary.main, 0.8),
                    }),
                })}>
                    {params.group || '---'}
                </Box>

                {/* Group Items styling using sx */}
                <ul style={{ padding: 0 }}>{params.children}</ul>
            </li>
        )}
    />);
}



